"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isElementInParentBlock = void 0;
const isElementInParentBlock = function (el, parent) {
  let viewPercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const rectInner = el.getBoundingClientRect();
  const rectParent = parent.getBoundingClientRect();
  const vertTopInView = rectInner.top + rectInner.height * viewPercent <= rectParent.height + rectParent.top;
  const horLeftInView = rectInner.left + rectInner.width * viewPercent <= rectParent.width + rectParent.left;
  return vertTopInView && horLeftInView;
};
exports.isElementInParentBlock = isElementInParentBlock;